module.exports = __webpack_public_path__ + "static/img/topbag.6ede9bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/pregnancyProject/images/topbag.png
// module id = C19p
// module chunks = 7